export const BASIC_POKEMON = 'basic_pokemon';
export const STAGE_2 = 'stage_2';
export const STAGE_1 = 'stage_1';
export const POKEMON = 'pokemon';
export const TRAINER = 'trainer';
export const BASIC_ENERGY = 'basic_energy';
export const ENERGY = 'energy';

/** The sets, by expansion id, as their names are printed, in the order they came out. */
export const EXPANSION_NAMES = {
  base: 'Base Set',
  jungle: 'Jungle',
  fossil: 'Fossil',
  'base-2': 'Base Set 2',
  'team-rocket': 'Team Rocket',
  'gym-heroes': 'Gym Heroes',
  'gym-challenge': 'Gym Challenge',
  'wizards-promos': 'Wizards Black Star Promos',
};
